import Enum from './Enum.js';

export default class KpiWeightType extends Enum {
  static KPI = new KpiWeightType('KPI', '数値目標');
  static PERSONAL_GOAL = new KpiWeightType('PERSONAL_GOAL', '個人目標');
  static SKILL = new KpiWeightType('SKILL', 'スキル');
}
